import React from 'react';
import Select from 'react-select';
import BaseComponent from "../../../baseComponent.js";

import { variableTypes } from "./constants";
import styles from './variable.scss';

export class Variable extends BaseComponent {
  constructor(props) {
    super(props);
  }

  handleChange(field, value) {
    this.props.onFieldChange(this.props.index, field, value);
  }

  requireFormat() {
    const type = this.props.variable.type;
    return type === variableTypes.DATE || type === variableTypes.DATETIME || type === variableTypes.TIME;
  }

  render() {
    const variableTypeOptions = [];
    for (let prop in variableTypes) {
      variableTypeOptions.push({ value: variableTypes[prop], label: prop });
    }
    return (
      <tr style={{ height: "40px" }}>
        <td>
          <input type="text" className={styles.input} value={this.props.variable.name}
            placeholder="Enter name"
            onChange={(e) => this.handleChange("name", e.target.value)} />
        </td>
        <td>
          <Select
            name="variable-type"
            value={this.props.variable.type}
            options={variableTypeOptions}
            onChange={(option) => this.handleChange("type", option.value)} />
        </td>
        <td>
          {
            this.requireFormat() ?
              <input type="text" className={styles.input} value={this.props.variable.dateTimeFormat} style={{width: "120px"}}
                placeholder="Enter format"
                onChange={(e) => this.handleChange("dateTimeFormat", e.target.value)} />
              : null
          }
        </td>
        <td className={styles.remove}>
          <div>
            <i className="material-icons"
              onClick={() => this.props.onRemove(this.props.index)}>remove_circle_outline</i>
          </div>
        </td>
      </tr>
    );
  }
}

Variable.contextTypes = {
  variable: React.PropTypes.object,
  onRemove: React.PropTypes.func,
  onFieldChange: React.PropTypes.func,
  index: React.PropTypes.number
};
//
//
// <select value={this.props.variable.type} ref="type">
//   <option value="" disabled>Select type
//   </option>
//   <option value="1">NUMBER</option>
//   <option value="2">BOOLEAN</option>
//   <option value="3">STRING</option>
//   <option value="4">DATE</option>
//   <option value="5">TIME</option>
//   <option value="5">UUID</option>
// </select>
//



// WEBPACK FOOTER //
// ./src/components/dashboard/control-widget/selection-contorl/variable.jsx